import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the InttotextPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'inttotext',
})
export class InttotextPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, args?) {
    if(value==="1"){
      return "Ja";
    }
    else if(value==="0"){
      return "Nein";
    }
    else{
      return "";
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/pipes/inttotext/inttotext.ts